export const DEBOUNCE_INTERVAL = 250;
